import { render } from "./AnalyticsChart.vue?vue&type=template&id=084b2062"
import script from "./AnalyticsChart.vue?vue&type=script&lang=js"
export * from "./AnalyticsChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/AnalyticsChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "084b2062"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('084b2062', __exports__)) {
    api.reload('084b2062', __exports__)
  }
  
  module.hot.accept("./AnalyticsChart.vue?vue&type=template&id=084b2062", () => {
    api.rerender('084b2062', render)
  })

}


export default __exports__